module.exports = __webpack_public_path__ + "static/media/upload-icon.3f346208.svg";